import React from "react";
import PropTypes from "prop-types";

const ReleaseFormsPage = ({
  data,
  signatureData,
  staffSignatureData,
  currentDate,
}) => {
  const name = `${data.personalContact.firstName} ${data.personalContact.lastName}`
  return (
    <div
      style={{
        fontFamily: "Elef Layla MF",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.2",
        height: "1200px",
        fontSize: "18px",
      }}
    >
      {/* Title */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <h2
          style={{
            fontSize: "16pt",
            borderBottom: "2px solid black",
            display: "inline-block",
            textTransform: "uppercase",
          }}
        >
          STAFF TRANSPORT RELEASE
        </h2>
      </div>

      <div style={{ marginBottom: "20px" }}>
        <p style={{ marginBottom: "15px" }}>
          I understand that due to lack of my own personal transportation, I may
          need to rely on staff for transportation.
        </p>
        <p style={{ marginBottom: "15px" }}>
          I hereby indemnify Legacy Healing Center Margate, LLC and their staff
          from all damage or injury caused to me or others when I willingly
          accept transportation to or from any location or event, whether it's
          related to Legacy Healing Center, LLC or not.
        </p>
      </div>

      <div
        style={{
          marginTop: "30px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "30px" }}>
            <img
              src={signatureData || ""}
              alt="Client Signature"
              style={{
                width: "200px",
                height: "70px",
                borderBottom: "1px solid black",
              }}
            />
            <p>
              <span>Client Signature:</span>
            </p>
          </div>
        </div>
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "20px", marginTop: signatureData ? "60px" : "0", }}>
            {/* {!currentDate && ( */}
            <div>{currentDate}</div>
            <div
              style={{
                borderBottom: "1px solid black",
                width: "300px",
                // height: "30px",
              }}
            ></div>
            {/* )} */}
            <p>Date:</p>
          </div>
        </div>
      </div>

      {/* Search Attestation Section */}
      <section style={{ marginBottom: "30px" }}>
        {/* Title */}
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <h2
            style={{
              fontSize: "16pt",
              paddingBottom: "5px",
              borderBottom: "2px solid black",
              display: "inline-block",
              textTransform: "uppercase",
            }}
          >
            SEARCH ATTESTATION
          </h2>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <p style={{ marginBottom: "15px" }}>
            By signing this form, I attest that a complete and thorough search
            of my person and property has been conducted. I also want to
            acknowledge that I understand that staff reserves the right to
            search my person and property at any time.
          </p>
          <p style={{ marginBottom: "15px" }}>
            Client's clothing, body, luggage, and all items brought into the
            community have been checked.
          </p>
        </div>

        <div style={{ marginTop: "40px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
              marginRight: "30px",
            }}
          >
            <div style={{ textAlign: "center", flex: 1 }}>
              <div style={{ marginBottom: "30px" }}>
                <img
                  src={signatureData || ""}
                  alt="Client Signature"
                  style={{
                    width: "200px",
                    height: "70px",
                    borderBottom: "1px solid black",
                  }}
                />
                <p>
                  <span>Client Signature:</span>
                </p>
              </div>
            </div>
            <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "20px", marginTop: signatureData ? "60px" : "0", }}>
            {/* {!currentDate && ( */}
            <div>{currentDate}</div>
            <div
              style={{
                borderBottom: "1px solid black",
                width: "300px",
                // height: "30px",
              }}
            ></div>
            {/* )} */}
            <p>Date:</p>
          </div>
        </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginRight: "30px",
            }}
          >
            <div style={{ textAlign: "center", flex: 1 }}>
              <div style={{ marginBottom: "30px" }}>
                <img
                  src={staffSignatureData || ""}
                  alt="Client Signature"
                  style={{
                    width: "200px",
                    height: "70px",
                    borderBottom: "1px solid black",
                  }}
                />
                <p>
                  <span>Staff Signature:</span>
                </p>
              </div>
            </div>
            <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "20px", marginTop: signatureData ? "60px" : "0", }}>
            {/* {!currentDate && ( */}
            <div>{currentDate}</div>
            <div
              style={{
                borderBottom: "1px solid black",
                width: "300px",
                // height: "30px",
              }}
            ></div>
            {/* )} */}
            <p>Date:</p>
          </div>
        </div>
          </div>
        </div>
      </section>

      {/* Celebration Point Release Section */}
      <section style={{ marginBottom: "20px" }}>
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <h2
            style={{
              fontSize: "16pt",
              paddingBottom: "5px",
              borderBottom: "2px solid black",
              display: "inline-block",
              textTransform: "uppercase",
            }}
          >
            CELEBRATION POINT - RELEASE OF PHOTO, NAME AND APARTMENT NUMBER
          </h2>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <p style={{ marginBottom: "15px" }}>
            I, { name || "______________________"}, give Legacy Healing Center Margate LLC
            permission to release my photograph along with my first name and
            last initial to Celebration Point leasing office. By signing this
            document, I grant Legacy Healing Center Margate LLC all rights to
            use my image for Celebration Point leasing office to identify,
            support and uphold the integrity of the community.
          </p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
            marginRight: "30px",
            marginRight: "20px",
          }}
        >
          <div style={{ textAlign: "center", flex: 1 }}>
            <div style={{ marginBottom: "30px" }}>
              <img
                src={staffSignatureData || ""}
                alt="Client Signature"
                style={{
                  width: "200px",
                  height: "70px",
                  borderBottom: "1px solid black",
                }}
              />
              <p>
                <span>Staff Signature:</span>
              </p>
            </div>
          </div>
          <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "20px", marginTop: signatureData ? "60px" : "0", }}>
            {/* {!currentDate && ( */}
            <div>{currentDate}</div>
            <div
              style={{
                borderBottom: "1px solid black",
                width: "300px",
                // height: "30px",
              }}
            ></div>
            {/* )} */}
            <p>Date:</p>
          </div>
        </div>
        </div>
      </section>
    </div>
  );
};

ReleaseFormsPage.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
};

export default ReleaseFormsPage;
